module.exports = __webpack_public_path__ + "img/setup4.3f6aeeb4.png";